import { render, staticRenderFns } from "./EditAdditionalInfoContainer.vue?vue&type=template&id=eb28b0a6"
import script from "./EditAdditionalInfoContainer.vue?vue&type=script&lang=js"
export * from "./EditAdditionalInfoContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports